export enum CallStatusesEnum {
  SUCCESS = 'Success',
  MISSED = 'missed',
  CANCEL = 'Cancel',
  BUSY = 'Busy',
  NOT_AVAILABLE = 'NotAvailable',
  NOT_ALLOWED = 'NotAllowed',
  NOT_FOUND = 'NotFound'
}
